import styled from '@emotion/styled';

export const Container = styled.div`
	width: 100%;
`;

export const DropZone = styled.div<{ isDragging: boolean }>`
	border: 1px solid #adb5bd;
	padding: 1.2rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	transition: all 0.2s ease;
	cursor: pointer;
	${(props) =>
		props.isDragging &&
		`
    border-color: #3b82f6;
    background-color: #eff6ff;
  `}
	p {
		color: #adb5bd;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: ${(props) => props.theme.lineHeight.tight};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	}
`;
export const HiddenInput = styled.input`
	display: none;
`;
export const DropText = styled.p`
	color: #4b5563;
	font-size: 16px;
`;
export const FileList = styled.div`
	margin-top: 16px;
`;
export const FileListUl = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
export const FileItem = styled.li<{ deleted?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 4px;

	display: flex;
	gap: 1.2rem;
	align-items: center;
	padding: 1.2rem;
	background-color: ${(props) => (props.deleted ? '#E9ECEF' : '#fff')};
	border: 1px solid #dee2e6;
	cursor: pointer;
	opacity: ${(props) => (props.deleted ? '0.5' : '1')};
`;

export const FileName = styled.span`
	font-size: 14px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const FileContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	max-width: 13.6rem;
	width: 100%;
	.title {
		font-size: 1.4rem;
		font-weight: 400;
		line-height: ${(props) => props.theme.lineHeight.tight};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		color: #212529;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.sub_title {
		font-size: 1.2rem;
		font-weight: 400;
		line-height: ${(props) => props.theme.ui.lineHeight.heading};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		color: #868e96;
	}
`;
